import React, { useCallback, useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { openUrlByApp, trackAdClick, trackAdImpression } from "utils/ad.utils";
import AdApi from "utils/wApi";

/**
 * 1. 탭 - 플레이
 *     - 포지션명 : TabPlay
 * @constructor
 */
const AdMenu = () => {
	const adCategory = "kiosk_banner";
	const adPositionName = "Kiosk";
	const [adID, setAdID] = useState();
	const [adLink, setAdLink] = useState();
	const [adImageUrl, setAdImageUrl] = useState();
	const [adOn, setAdOn] = useState(false);

	useEffect(() => {
		if (adOn && adID) {
			trackAdImpression(adCategory, adPositionName, adID);
		}
	}, [adOn, adID]);

	const handleClick = useCallback(() => {
		if (adOn && adID && adLink) {
			openUrlByApp(adLink);
			trackAdClick(adCategory, adPositionName, adID);
		}
	}, [adOn, adID, adLink]);

	const loadData = useCallback(async () => {
		try {
			const { data } = await AdApi.ad(null, adCategory, {});

			setAdImageUrl(data.imageUrl);
			setAdID(`ad_${data.id}_${adCategory}`);
			setAdOn(true);
		} catch (error) {
			console.error("Failed to load ad data", error);
		}
	}, []);

	useEffect(() => {
		loadData();
	}, [loadData]);

	return adOn ? (
		<Grid
			item
			sx={{
				width: "calc(33% - 10px)",
			}}
			className={adID}
			data-id={adID}
		>
			<Box
				sx={{
					width: "100%",
					height: "35.5vw",
					borderRadius: 0.5,
					background: `center/cover no-repeat url(${adImageUrl})`,
				}}
			/>

			<Typography
				variant="body1"
				sx={{
					mt: 1,
					py: 0.25,
					px: 1,
					border: "1px solid #E0E0E0",
					color: "grey.100",
					display: "inline-block",
					bgcolor: "grey.600",
					borderRadius: 0.5,
				}}
			>
				AD
			</Typography>
		</Grid>
	) : null;
};

export default AdMenu;
